
import {
  SUBMIT_RATING_REQUEST,
  SUBMIT_RATING_SUCCESS,
  SUBMIT_RATING_FAILURE,
  FETCH_RATINGS_REQUEST,
  FETCH_RATINGS_SUCCESS,
  FETCH_RATINGS_FAILURE,
  FETCH_TRUST_SCORE_REQUEST,
  FETCH_TRUST_SCORE_SUCCESS,
  FETCH_TRUST_SCORE_FAILURE,
} from '../../Action/Rating/ratingAction'

const init = {
  submitLoading: false,
  fetchLoading: false,
  ratings: [],
  average: null,
  count: 0,
  distribution: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 },
  recommendationPct: 0,
  alreadyRated: false,
  myRating: null,
  canRate: false,
  trustScore: null,
  trustScoreLoading: false,
  error: null,
}

const ratingReducer = (state = init, action) => {
  switch (action.type) {
    case SUBMIT_RATING_REQUEST:
      return {
        ...state,
        submitLoading: true,
        error: null,
      }

    case SUBMIT_RATING_SUCCESS:
      return {
        ...state,
        submitLoading: false,
        alreadyRated: true,
        myRating: action.payload?.rating || state.myRating,
        trustScore: action.payload?.trust_score ?? state.trustScore,
      }

    case SUBMIT_RATING_FAILURE:
      return {
        ...state,
        submitLoading: false,
        error: action.payload,
      }

    case FETCH_RATINGS_REQUEST:
      return {
        ...state,
        fetchLoading: true,
        error: null,
        trustScore: null,
      }

    case FETCH_RATINGS_SUCCESS: {
      const p = action.payload
      const isObject = p && typeof p === 'object' && !Array.isArray(p)

      return {
        ...state,
        fetchLoading: false,
        ratings: isObject ? (p.ratings || []) : (p || []),
        average: isObject ? p.average : null,
        count: isObject
          ? (p.count ?? p.ratings?.length ?? 0)
          : (p?.length || 0),
        distribution: isObject
          ? (p.distribution || init.distribution)
          : init.distribution,
        recommendationPct: isObject
          ? (p.recommendation_pct ?? 0)
          : 0,
        alreadyRated: isObject
          ? Boolean(p.already_rated)
          : false,
        myRating: isObject ? p.my_rating : null,
        canRate: isObject ? Boolean(p.can_rate) : false,
        trustScore: isObject ? (p.trust_score ?? null) : null,
      }
    }

    case FETCH_RATINGS_FAILURE:
      return {
        ...state,
        fetchLoading: false,
        error: action.payload,
      }

    case FETCH_TRUST_SCORE_REQUEST:
      return {
        ...state,
        trustScoreLoading: true,
        error: null,
      }

    case FETCH_TRUST_SCORE_SUCCESS:
      return {
        ...state,
        trustScoreLoading: false,
        trustScore: action.payload?.trust_score ?? action.payload ?? null,
      }

    case FETCH_TRUST_SCORE_FAILURE:
      return {
        ...state,
        trustScoreLoading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default ratingReducer
